import React from "react";
import { Label } from "../../ui/label";

/**
 * Shared prompt, help text, and error chrome around a question control.
 *
 * @param {Object} props
 * @param {object} props.question
 * @param {string} [props.error]
 * @param {boolean} [props.indent]
 * @param {boolean} [props.showRequired]
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export default function QuestionFrame({
  question,
  error,
  indent = false,
  showRequired = false,
  children,
}) {
  const fieldId = `survey-q-${question.id}`;
  return (
    <div className="flex flex-col gap-2">
      <div>
        <Label htmlFor={fieldId} className="text-base">
          {question.prompt}
          {showRequired ? (
            <span className="ml-1 text-error" aria-hidden>
              *
            </span>
          ) : null}
        </Label>
      </div>
      {question.helpText ? (
        <p className="text-sm text-text-secondary">{question.helpText}</p>
      ) : null}
      <div className={indent ? "flex flex-col gap-2 pl-6 sm:pl-8" : "flex flex-col gap-2"}>
        {children}
        {error ? (
          <p className="text-sm text-error" role="alert">
            {error}
          </p>
        ) : null}
      </div>
    </div>
  );
}
